/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

 import { defineComponent, PropType } from "vue";

 export default defineComponent({
   props: {
     size: {
        type: String as PropType<"medium" | "small" | "large">,
        default: "medium"
     }
   }
 });
 